import { UrlConstants } from "../url.constants";
export class ApiModuleConstants {
    static URL = UrlConstants.API_V2 + "Module";
    static UPLOAD_INVOICE_TEMPLATE = "UploadInvoiceTemplate";
    static FUNCTION_DOWNLOAD_INVOICE_TEMPLATE = "DownloadInvoiceTemplate";
    static FUNCTION_DOWNLOAD_MODULE_STAMP = "DownloadStamp";
    static FUNCTION_GET_MODULE_STAMPS = "GetModuleStamps";
    static FUNCTION_DOWNLOAD_MODULE_STAMP_BASE_64 = "DownloadStampBase64";
    static FUNCTION_BACKUP_SETTINGS = "BackupSettings";
    static FUNCTION_RESTORE_SETTINGS = "RestoreSettings";
    static FUNCTION_BACKUP_MODULE_SETTINGS = "BackupModuleSettings";
    static MISSING_LOOKUP_EMAIL_REQUEST_URL = "SendMissingLookupEmail";
    static MODULE_SETTINGS = UrlConstants.API_V2 + "ModuleSetting";
    static FUNCTION_GET_HELP_FILE = "GetHelpFileContent";
    static FUNCTION_UPLOAD_HELP_FILE = "UploadHelpFile";
    static FUNCTION_GET_HELP_FILE_INFORMATION = "GetHelpFileInformation";
}
